import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const currentBsdState = atom({
  key: "currentBsdState",
  default: null,
  effects_UNSTABLE: [persistAtom],
});
